"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: {
            marginTop: '12px',
            marginRight: '-24px',
        },
        endIcon: {
            padding: theme.spacing(0, 2.5),
            height: theme.spacing(4),
        },
    });
});
